import {
  getListItemEntry,
  ELEMENT_UL,
  ELEMENT_LI,
  ELEMENT_MEDIA_EMBED,
  ELEMENT_IMAGE,
} from '@udecode/plate';

import { withList } from './withList';
import { ListItemElement } from './ListItemElement';

export const withInsertFragmentList = (editor, options) => {

  const _editor = withList(editor, options);

  const { insertNodes } = _editor;

  _editor.insertNodes = (nodes, _options) => {
    // We only want to split the node if it's not an inline node.
    const nodesIsInline = nodes.length ? nodes.every(node => _editor.isInline(node)) :
      _editor.isInline(nodes);

    const listRes = getListItemEntry(_editor);
    if (listRes && !nodesIsInline) {
      insertNodes(nodes, { ..._options, mode: 'highest', split: true });
      return;
    }

    insertNodes(nodes, _options);
  };

  return _editor;
};

export const listPlugin = {
  options: {
    validChildrenTypes: [ELEMENT_IMAGE, ELEMENT_MEDIA_EMBED],
  },
  withOverrides: withInsertFragmentList,
  then: () => ({
    inject: {
      props: {
        classNames: {
          disc: 'slate-ul--disc',
          square: 'slate-ul--square',
          circle: 'slate-ul--circle',
          dash: 'slate-ul--dash',
        },
        styleKey: null,
        nodeKey: 'listStyleType',
        defaultNodeValue: 'disc',
        validNodeValues: ['disc', 'square', 'circle', 'dash'],
        validTypes: [ELEMENT_UL],
      },
    },
  }),
};

export const listPluginByKey = {
  [ELEMENT_UL]: {
    deserializeHtml: {
      rules: [
        {
          validNodeName: 'UL',
        },
      ],
      getNode: (element) => {
        return {
          type: ELEMENT_UL,
          listStyleType: element.style.listStyleType,
        };
      },
    },
  },
  [ELEMENT_LI]: {
    serializeHtml: ListItemElement,
  },
};
